import { testimonials } from '@/mocks/homeData';

export default function TestimonialSection() {
  return (
    <section className="py-12 md:py-16 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        {/* Section header */}
        <div className="text-center mb-10">
          <span className="inline-block px-4 py-1.5 text-xs font-medium text-accent-700 bg-accent-100/50 rounded-full mb-3">
            用户口碑
          </span>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-2">
            动漫爱好者都在用51动漫
          </h2>
          <p className="text-foreground-500 text-sm">
            听听他们怎么说
          </p>
        </div>

        {/* Testimonial cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6">
          {testimonials.map((t) => (
            <div
              key={t.id}
              className="relative rounded-2xl p-5 md:p-6 bg-background-100 border border-background-200/60"
            >
              {/* Quote icon */}
              <div className="mb-4">
                <i className="ri-double-quotes-l text-3xl text-accent-300"></i>
              </div>

              {/* Content */}
              <p className="text-sm text-foreground-700 leading-relaxed mb-5">
                {t.content}
              </p>

              {/* Rating */}
              <div className="flex items-center gap-1 mb-4">
                {Array.from({ length: t.rating }).map((_, i) => (
                  <i key={i} className="ri-star-fill text-accent-500 text-sm"></i>
                ))}
              </div>

              {/* Author */}
              <div className="flex items-center gap-3 pt-4 border-t border-background-200/40">
                <div className="w-10 h-10 rounded-full overflow-hidden bg-background-300 flex-shrink-0">
                  <img
                    src={t.avatar}
                    alt={t.name}
                    className="w-full h-full object-cover"
                    loading="lazy"
                  />
                </div>
                <div>
                  <p className="text-sm font-semibold text-foreground-900">{t.name}</p>
                  <p className="text-xs text-foreground-400">{t.role}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}